import React from "react"
import { useTranslation } from "react-i18next"

import {
  LinkListBehavior,
  LinkListContext
} from "shared/context/LinkListContext"
import { ColorScheme } from "shared/context/color-scheme/ColorScheme"
import { useIsProductConfigurationPage } from "shared/lib/useIsProductConfigurationPage"

import { ColorSchemeSelect } from "widgets/color-scheme-select/ColorSchemeSelect"

import { PortalVersion } from "./PortalVersion"
import "./styles/_footer.scss"

export interface FooterViewModel {
  address: React.ReactNode
  socials: React.ReactNode
  topLinks: React.ReactNode
  bottomLinks: React.ReactNode
}

const desktopLinkListContext = {
  behavior: LinkListBehavior.LIST
}

const mobileLinkListContext = {
  behavior: LinkListBehavior.ACCORDION
}

export const FooterView = React.memo(
  React.forwardRef<HTMLElement, FooterViewModel>(
    ({ address, socials, topLinks, bottomLinks }, ref) => {
      const { t } = useTranslation()
      const isProductConfigurationPage = useIsProductConfigurationPage()
      if (isProductConfigurationPage) {
        return null
      }

      return (
        <footer
          ref={ref}
          className="footer"
          data-testid="footer"
          data-bs-theme={ColorScheme.DARK}
          aria-label={t("Footer.Footer")}
        >
          <div className="footer">
            <div className="footer-row top">
              <div className="logo logo-white" />
              <LinkListContext.Provider value={desktopLinkListContext}>
                <div className="footer__top-links-variant tablet-hidden">
                  {topLinks}
                </div>
              </LinkListContext.Provider>
              <LinkListContext.Provider value={mobileLinkListContext}>
                <div className="footer__top-links-variant desktop-hidden">
                  {topLinks}
                </div>
              </LinkListContext.Provider>
              {socials}
            </div>
            <div className="divider" />
            <div className="footer-row bottom">
              {address}
              {bottomLinks}
              <div className="footer__language-select">
                <ColorSchemeSelect />
                {/* <LanguageSwitch /> */}
              </div>
            </div>
            <PortalVersion />
          </div>
        </footer>
      )
    }
  )
)
